module.exports = __webpack_public_path__ + "static/media/no-results.ee05890b.svg";